import React from "react";
import {
  Grid,
  Stack,
  Typography,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import advisory from "./../images/advisory.jpeg";
import implement from "./../images/implement.jpeg";
import develop from "./../images/develop.jpeg";
import intergate from "./../images/intergate.jpeg";

import useMediaQuery from "@mui/material/useMediaQuery";

const CrmErp = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");

  const costStyle = {
    flexGlow: 1,
    padding: vMediaQuery ? "20px" : "50px 140px",
    backgroundColor: "#f5faf2",
    textAlign: "center",
  };

  const crmErpCard = {
    backgroundColor: "#357ec7",
    textAlign: "center",
    color: "white",
    borderRadius: "16px",
    minHeight: "44vh",
  };

  return (
    <Box sx={costStyle}>
      <h1 style={{ color: "#357ec7", fontSize: vMediaQuery ? "20px" : "34px" }}>
        Microsoft Dynamics 365{" "}
        <strong style={{ color: "green" }}>CRM & ERP Applications</strong>
      </h1>
      <Typography
        variant={vMediaQuery ? "body2" : "subtitle1"}
        sx={{ letterSpacing: 1, }}
      >
        Though implementation is our forte, we wouldn’t have done it without a
        solid advisory team {vMediaQuery || <br />} and a development team to
        achieve customer success.
      </Typography>
      <Grid
        container
        spacing={vMediaQuery ? 1 : 3}
        sx={{ padding: vMediaQuery ? "20px 10px" : "30px 80px" }}
      >
        <Grid item xs={12} md={3} lg={3}>
          <Card sx={crmErpCard}>
            <CardContent>
              <Stack>
                <div className="crmErp-contanierLCQ">
                  <img className="crmErp" alt="certificates" src={advisory} />
                </div>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  Advisory Services{" "}
                </Typography>
                <Typography variant="body2" sx={{ padding: "6px", marginTop: "2px" }}>
                  Our Microsoft Dynamics 365 consulting services team creates
                  the blueprint for your continued success with Microsoft
                  Dynamics 365.
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <Card sx={crmErpCard}>
            <CardContent>
              <Stack>
                <div className="crmErp-contanierLCQ">
                  <img className="crmErp" alt="certificates" src={implement} />
                </div>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  Implementation
                </Typography>
                <Typography variant="body2" sx={{ padding: "6px", marginTop: "2px" }}>
                  GDR Consultancy follows a tried-and-tested implementation
                  methodology that is engineered with a Plan, Build, Test, and
                  Deploy process.
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <Card sx={crmErpCard}>
            <CardContent>
              <Stack>
                <div className="crmErp-contanierLCQ">
                  <img className="crmErp" alt="certificates" src={develop} />
                </div>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  Development & Customization
                </Typography>
                <Typography variant="body2" sx={{ padding: "6px", marginTop: "2px" }}>
                  Get Microsoft Dynamics 365 features configured to suit your
                  specific business needs and custom apps developed that align
                  with your business needs.
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <Card sx={crmErpCard}>
            <CardContent>
              <Stack>
                <div className="crmErp-contanierLCQ">
                  <img className="crmErp" alt="certificates" src={intergate} />
                </div>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  Integration{" "}
                </Typography>
                <Typography variant="body2" sx={{ padding: "6px", marginTop: "2px" }}>
                  Get Microsoft Dynamics connected to multiple data sources and
                  all your third-party tools to create a unified view of your
                  enterprise.
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CrmErp;
